window.FontAwesomeConfig = {
	autoReplaceSvg: true,
	observeMutations: true,
	autoAddCss: false,
	styleDefault: null,
};
